import { useState } from "react";
import { callAPIForQuery } from "../../../utilities/service";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const HospitalView = () => {
    const navigate = useNavigate();
    const [hospitals, setHospitals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [input, setInput] = useState({
        from_date: moment().format('YYYY-MM-DD'),
        to_date: moment().format('YYYY-MM-DD'),
    });

    const updateInputInfo = (key: string, value: string) => {
        setInput((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    const fetchHospitals = async () => {
        setLoading(true);
        setError(""); // Clear previous errors
        try {
            const response = await callAPIForQuery(
                { input: JSON.stringify({ from_date: input.from_date, to_date: input.to_date }), type: "get_hospital" },
                "post"
            );
            setHospitals(response[0] || []);
        } catch (err) {
            setError("Failed to load hospitals");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-lg-2">
                    <div className="form-option">
                        <label className="field-title">From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={input.from_date}
                            onChange={(e) => updateInputInfo("from_date", e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-2">
                    <div className="form-option">
                        <label className="field-title">To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={input.to_date}
                            onChange={(e) => updateInputInfo("to_date", e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-1">
                    <div className="form-option">
                        <label className="field-title hide">Search</label>
                        <input type="button" value="Search" className="form-control" onClick={fetchHospitals} />
                    </div>
                </div>
            </div>

            {loading && <p>Loading hospitals...</p>}
            {error && <p className="text-danger">{error}</p>}

            <div className="appointment-grid">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Hospital Code</th>
                            <th>Hospital Name</th>
                            <th>Contact No</th>
                            <th>Address</th>
                            <th>Pincode</th>
                            <th>Email</th>
                            <th>Tenant</th>
                            <th>Active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hospitals.length > 0 ? (
                            hospitals.map((hospital: any) => (
                                <tr key={hospital.id}>
                                    <td>{hospital.id}</td>
                                    <td>{hospital.hospital_code}</td>
                                    <td>{hospital.hospital_name}</td>
                                    <td>{hospital.contact_no}</td>
                                    <td>{hospital.address}</td>
                                    <td>{hospital.pincode}</td>
                                    <td>{hospital.email_id}</td>
                                    <td>{hospital.tenant_name}</td>
                                    <td>{hospital.isactive ? "Yes" : "No"}</td>
                                    <td><span className="action-link" onClick={() => {
                                        navigate(`/hospital-create?id=${hospital.id}`)
                                    }}>View</span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={9} className="text-center">No hospitals found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default HospitalView;
